import { render, staticRenderFns } from "./ShopStoreCategory.vue?vue&type=template&id=68dd59ac&scoped=true"
import script from "./ShopStoreCategory.vue?vue&type=script&lang=js"
export * from "./ShopStoreCategory.vue?vue&type=script&lang=js"
import style0 from "./ShopStoreCategory.vue?vue&type=style&index=0&id=68dd59ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dd59ac",
  null
  
)

export default component.exports